import { useTranslation } from 'react-i18next'

const HomophobicAdultStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="homophobic-adult-start-title"
      {...props}
    >
      <title id="homophobic-adult-start-title">{t('antagonists:homophobicAdult:components:start')}</title>
      <defs>
        <clipPath id="homophobic-adult-a">
          <path
            d="M1502.23 374.83s-3.03 23.86 26.3 26.72c29.33 2.86 35.87-5.31 39.45-15.68 3.58-10.37-2.53-18.21-2.53-18.21l51.6 28.99s-29.33 106.6-24.68 149.16c4.65 42.57 24.21 89.42 32.54 131.09 7.3 36.49 16.67 125.01 16.67 125.01s-66.38 13.25-112.52 15.05c-67.97 2.65-120.83-21.71-120.83-21.71s2.78-67 12.8-116.36c10.02-49.36 31.84-123.05 34.34-150.24 2.5-27.19.33-135.02.33-135.02l44.74-20.58 1.79 1.79Z"
            style={{
              fill: '#00a39a',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1438.26 389.52c-11.29 5.13-18.47 86.19-18.47 86.19l52.33 34.88s11.29-117.99-7.18-125.17c-18.47-7.18-26.68 4.1-26.68 4.1Z"
        style={{
          fill: '#71ae52',
        }}
      />
      <path
        d="M1441.49 383.58c-13.45 1.31-15.47 25.94-18.37 41.9-2.9 15.96-13.55 71.27-13.55 71.27l60.22 5.08 34.1-120.43s-22.1-3.49-35.55-2.18l-26.84 4.35Z"
        style={{
          fill: '#71ae52',
        }}
      />
      <path
        d="M1556.63 256.11c-3.07-1.38-10.85-12.91-29.77-6.95-23.78 7.48-16.58 17.47-25.49 23.36-8.91 5.88-17.73 16.06-15.59 25.51s7.21 21.38 5.42 27.44c-1.78 6.06 2.61 14.96 13.3 23.88 10.7 8.91 18.43 16.41 38.04 18.2 19.61 1.78 7.61-12.13 12.82-10.49 7.81 2.46 17.32 1.75 18.95-2.71 1.11-3.03-5.36-5.01 4.78-14.08 4.51-4.04 11.29-5.77 15.57-15.58s1.37-17.94-3.27-31.31c-4.64-13.37-6.24-21.93-15.33-27.99-9.09-6.06-15.87-7.67-19.43-9.27Z"
        style={{
          fill: '#eaeaea',
        }}
      />
      <path
        d="M1509.55 340.57s4.85 13.75 1.19 18.3c-3.66 4.55-14.64 9.59-14.64 9.59s-2.67 43.82-2.47 43.42 82.19 2.18 82.19 2.18-1.46-35.12-2.25-34.82-6.46-10.87-10.91-17.5c-4.45-6.63 1.58-18.3 1.58-18.3l-54.7-2.87Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1546.56 279.88c-11.59-1.58-18.84-7.34-25.79-3.6-6.95 3.74-12.3 6.6-11.95 13.55.36 6.95.71 17.47-1.78 20.68-2.5 3.21-6.16 3.22-9.73 3.75s-5.07 3.38-3.82 13.54c1.25 10.16 5.2 15.75 7.67 16.4 3.78.99 3.92-1.78 4.81-.89s1.96 8.56 6.95 14.08 13.91 11.41 21.04 11.77 22.64-1.78 27.1-5.88 7.31-13.37 8.91-12.84c1.6.53 1.6 4.28 6.6-1.96 4.99-6.24 8.88-16.95 7.45-19.63-1.43-2.67-6.56-.52-7.45-4.8s-3.92-16.58-2.32-23.18c1.6-6.6 3.03-11.41-3.21-18.19-6.24-6.77-16.64-1.75-24.48-2.82Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1548.04 298.8c3.36-.59 12.96-2.97 15.73-.89 2.77 2.08 5.84 5.96 5.84 5.96l-1.09.99s-3.58-4.17-7.24-4.47-12.35 1.57-12.35 1.57l-.89-3.17ZM1532.91 301.77l1.78-2.77s-12.46-5.74-15.73-5.24c-3.26.49-6.78 3.48-6.78 3.48l.65 1.46s5.03-2.98 7.6-2.18c2.57.79 12.47 5.26 12.47 5.26Z"
        style={{
          fill: '#d5d6d7',
        }}
      />
      <path
        d="m1553.85 313.61 5.66-.81-.49-1.86-6.47.49s1.14 2.24 1.29 2.18Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1554.17 311.94c1.51 1.04 1.87 2.79.8 4.23-1.08 1.44-2.84 1.46-4.25.61-1.67-1-2.01-2.56-1.05-4.16.67-1.13 2.95-1.76 4.51-.69ZM1524.55 310.54l-5.9-.97.57-2.02 6.47.81s-.99 2.26-1.13 2.18Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1523.9 308.88c-1.49 1.06-1.83 2.82-.73 4.24 1.1 1.42 2.87 1.45 4.26.58 1.65-1.03 1.57-2.77.59-4.35-.69-1.11-2.59-1.57-4.13-.48Z"
        style={{
          fill: '#2e425b',
        }}
      />
      <path
        d="M1577.8 308.61s-9-4.22-19.43-4.43c-11.26-.23-11.95 2.85-13.71 3.86-1.1.63-1.32.18-3.77-.05-2.46-.23-2.74.31-3.75-.46-1.61-1.24-1.87-4.38-13.06-5.69-10.36-1.21-19.66 2.12-19.66 2.12l-.52 3.02s2.4.56 2.83 5.24c.43 4.68.77 10.16 13.86 11.29 13.09 1.13 15.12-5.05 16.06-7.46 1.11-2.83 1.39-4.56 2.35-4.78.61-.14 2.98-.23 3.57 0 .92.34.71 2.33 1.42 5.28.6 2.52 1.53 8.83 14.64 9.49 13.12.66 14.45-4.64 15.52-9.22 1.07-4.58 3.68-4.08 3.68-4.08l-.02-4.13Zm-50.04 11.89c-5.54 1.51-14.3.21-16.87-3.65-2.08-3.12-2.16-6.27-2.07-9.18.1-3.37 6.62-3.78 13.79-3.47 7.17.31 12.21 2.37 11.98 7.7-.23 5.33-2.66 7.46-6.83 8.59Zm40.73.54c-3.43 1.99-7.94 2.86-15.13.97-5.5-1.45-7.18-4.36-6.67-9.67.5-5.31 5.67-6.28 12.81-5.61 7.14.67 13.08 1.9 12.46 6.05-.44 2.87-.31 6.43-3.47 8.26Z"
        style={{
          fill: '#5b3346',
        }}
      />
      <path
        d="M1521.53 346.22c1.03 1.35 2.37-.69 5.04.49 2.67 1.19 3.46 3.36 8.51 3.56s8.71-1.71 10.09-1.02c1.38.69 3.56.87 4.16-.15 1.09-1.86-4.95-6.15-8.02-6.44s-4.25.89-5.24.79-2.38-4.03-6.24-3.74-9.89 4.43-8.3 6.51Z"
        style={{
          fill: '#f1958d',
        }}
      />
      <path
        d="M1547.82 759.94c-1.43.72 12.16 37.56 16.45 51.15 4.29 13.59 13.21 56.64 15.38 69.75 4.38 26.53-.01 41.46 2.88 50.85 3.21 10.44 2.24 32.8 4.66 39.99 2.61 7.76 4.39 18.63 5.46 18.63s30.65-8.24 30.65-8.24-3.93-37.2-6.8-49.36c-2.86-12.16-4.76-26.02-3.69-33.53s5.12-55.9 4.04-74.5c-1.07-18.6-5.72-91.22-6.8-90.5s-62.24 25.75-62.24 25.75ZM1488.01 757.81s3.29 45.14 4.72 61.24c1.43 16.1-2.22 40.35-3.65 54.66-1.43 14.31-5.01 48.29-1.07 56.52 3.93 8.23 3.08 29.67 3.08 29.67l-20.25 35.08-29.33-4.29s8.23-15.74 12.16-24.68c3.93-8.94 5.01-16.45 4.65-30.76-.36-14.31-18.24-75.48-17.17-95.87s.72-42.57.36-53.66c-.36-11.09 3.22-38.27 3.22-38.27l43.28 10.37Z"
        style={{
          fill: '#d88b46',
        }}
      />
      <path
        d="M1599.71 981.31c13.21.73 20.36.4 21.08-6.04.72-6.44-1.22-24.13-1.22-24.13s4.79 27 5.51 33.79 2.49 15.18-4.31 18.04c-6.8 2.86-33.2 4.8-35.76-5.52-1.85-7.47.36-9.66.36-21.46s-2.86-23.61-2.5-26.11c.36-2.5 2.15-4.65 2.15-4.65s1.07 20.03 3.58 25.4c2.5 5.37 4.68 10.33 11.12 10.69ZM1448.66 988.53c7.21 1.62 22.18 1.07 26.47-5.37 4.29-6.44 10.37-18.24 12.52-25.04 2.15-6.8 3.23-14.99 3.23-14.99s7.14 11.05 4.28 19.64c-2.86 8.58-4.65 27.9-4.65 27.9l-6.08 2.5-5.63-1.54s-.81 7.98-2.6 10.84c-1.79 2.86-16.1 5.72-28.26 5.37-12.16-.36-15.55-5.23-11.8-13.59 2.4-5.36 9.94-12.39 9.94-12.39s-2.41 5.55 2.58 6.67Z"
        style={{
          fill: '#283a50',
        }}
      />
      <path
        d="M1671.06 472.13s-5.72 18.24-22.18 29.33c-16.45 11.09-17.64 13.77-26.47 17.89-8.83 4.11-21.82 6.8-23.61 11.09-1.79 4.29-.36 10.37-.36 16.45s4.29 17.53 8.58 19.67 9.3-.36 14.31-6.08 7.51-10.73 13.95-12.88c6.44-2.15 40.42-17.17 55.09-31.84 14.67-14.67 19.97-22.96 19.97-31.91s-.3-19.6-14.25-22.47c-13.95-2.86-25.04 10.73-25.04 10.73Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1502.23 374.83s-3.03 23.86 26.3 26.72c29.33 2.86 35.87-5.31 39.45-15.68 3.58-10.37-2.53-18.21-2.53-18.21l51.6 28.99s-29.33 106.6-24.68 149.16c4.65 42.57 24.21 89.42 32.54 131.09 7.3 36.49 16.67 125.01 16.67 125.01s-66.38 13.25-112.52 15.05c-67.97 2.65-120.83-21.71-120.83-21.71s2.78-67 12.8-116.36c10.02-49.36 31.84-123.05 34.34-150.24 2.5-27.19.33-135.02.33-135.02l44.74-20.58 1.79 1.79Z"
        style={{
          fill: '#00a39a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#homophobic-adult-a)',
        }}
      >
        <path
          d="M1471.37 383.58c0 2.13 19.18 36.23 62.51 39.07 43.33 2.84 73.16-36.23 73.16-36.23l2.13-45.46-135.67-.71-2.13 43.33ZM1379.11 758.31s77.43 29.83 128.57 34.1 149.98-22.25 149.98-22.25l-3.65 71.98s-218.78 19.18-218.78 16.34-81.69-76.72-81.69-76.72l25.57-23.44Z"
          style={{
            fill: '#006443',
          }}
        />
      </g>
      <path
        d="M1511.5 357.23s-2.54 4.29-3.63 15.24c-.77 7.79-.13 16.55 1.51 29.19 3.93 30.41 7.87 89.07 10.73 106.6 2.86 17.53-5.01 106.6-5.01 106.6s-21.8 2.95-49.7-6c-27.9-8.94-38.84-16.96-38.84-16.96s10.56-34.63 16.64-47.51c6.08-12.88 1.26-20.41-2.67-36.15-3.93-15.74-33.88-16.94-33.88-16.94s6.61-25.25 10.5-48.59c4.66-27.89 7.56-54.98 19.53-59.08 22.91-7.85 53.06-13.75 59.05-16.05 4.65-1.79 15.78-10.34 15.78-10.34ZM1562.47 361.76s15.95 33.81.57 80.67c-15.38 46.86-10.1 64.32-12.25 94.01s-1.07 79.05-1.07 79.05 21.36 3.43 37.82.92 32.42-7.57 32.42-7.57-5.33-14.27-9.37-31.69c-2.83-12.17-10.83-29.45-8.91-38.86 4.65-22.89 26.47-43.28 30.76-67.61s11.74-65.3-4.72-74.6c-16.45-9.3-36.99-16.14-45.22-20.08-8.23-3.93-20.02-14.25-20.02-14.25Z"
        style={{
          fill: '#71ae52',
        }}
      />
      <path
        d="M1619.55 394.51c-15.44 3.25-6.08 81.91 7.51 83.7 13.59 1.79 35.12 5.07 34.76 8.29-.36 3.22-4.97 7.23-4.97 7.23s16.48 10.32 26.86 13.54c10.37 3.22 19.18 6.36 19.18 6.36s15.74-26.83 12.16-37.92-29.68-28.36-49.71-45.18c-20.03-16.81-32.2-38.89-45.79-36.02Z"
        style={{
          fill: '#71ae52',
        }}
      />
      <path
        d="M1410.69 507.37s15.58-70.42 16.65-74.7c1.07-4.28-5.6-18.51-4.31-22 1.29-3.48 10.07-24.55 10.48-25.92.4-1.38 7.59-19.94 7.59-19.94s3.3 1.34 4.06 6.72c.28 2.01-2.79 9.14-1.98 14.48.25 1.67-1.73 12.3-1.48 12.68.43.65 12.02-2.07 13.54-1.1 2.15 1.38 7.58 6.54 8.46 11.28.56 3.03-8.08 11.57-8.99 13.26-.91 1.69.75 16.97-2.65 18.89-3.4 1.92-1.95 7-2.25 9.38l-8.84 69.73-30.27-12.76Z"
        style={{
          fill: '#e9b97d',
        }}
      />
      <path
        d="M1408.79 480.67s7.8 7.57 23.04 8.29 26.26 2.3 26.26 2.3 6.55 24.07 2.76 31.97c-8.03 16.74-25.5 9.56-38.56 10.28-13.06.73-16.26-13.47-18.85-24.85-2.25-9.89 5.35-28 5.35-28Z"
        style={{
          fill: '#71ae52',
        }}
      />
    </svg>
  )
}

export default HomophobicAdultStart